import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";

function AdminContactLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "contactLeads"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setLeads(rows);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-4">
      {/* List */}
      <div className="rounded-lg border border-gray-200 bg-white overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-sm font-extrabold text-gray-900">Contact Leads</h3>
          <span className="text-xs text-gray-500">{leads.length} total</span>
        </div>
        <div className="divide-y divide-gray-100">
          {loading ? (
            <div className="p-6 text-center text-gray-500">Loading...</div>
          ) : leads.length === 0 ? (
            <div className="p-6 text-center text-gray-500">No leads yet.</div>
          ) : (
            leads.map((lead) => (
              <button
                key={lead.id}
                onClick={() => setActive(lead)}
                className={`w-full text-left px-4 py-3 hover:bg-gray-50 ${active?.id === lead.id ? "bg-gray-50" : "bg-white"}`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm font-semibold text-gray-900">{lead.name || "(No name)"}</div>
                    <div className="text-xs text-gray-600 truncate max-w-[520px]">{lead.message || "(No message)"}</div>
                  </div>
                  <div className="text-xs text-gray-500">
                    {lead.createdAt?.toDate ? lead.createdAt.toDate().toLocaleString() : "—"}
                  </div>
                </div>
                <div className="mt-1 text-xs text-gray-500">{lead.email} • {lead.phone || lead.country || lead.source}</div>
              </button>
            ))
          )}
        </div>
      </div>

      {/* Details */}
      <div className="rounded-lg border border-gray-200 bg-white p-4 min-h-[300px]">
        {active ? (
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <h4 className="text-sm font-extrabold text-gray-900">Lead Details</h4>
              <span className="text-xs text-gray-500">{active.createdAt?.toDate ? active.createdAt.toDate().toLocaleString() : "—"}</span>
            </div>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <div>
                <dt className="text-gray-500">Name</dt>
                <dd className="font-semibold text-gray-900">{active.name || "—"}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Email</dt>
                <dd className="font-semibold text-gray-900 break-all">{active.email || "—"}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Phone</dt>
                <dd className="font-semibold text-gray-900">{active.phone || "—"}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Country</dt>
                <dd className="font-semibold text-gray-900">{active.country || "—"}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Interest</dt>
                <dd className="font-semibold text-gray-900">{active.interest || "—"}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Budget</dt>
                <dd className="font-semibold text-gray-900">{active.budget || "—"}</dd>
              </div>
              <div className="sm:col-span-2">
                <dt className="text-gray-500">Source</dt>
                <dd className="font-semibold text-gray-900">{active.source || "—"}</dd>
              </div>
            </dl>
            <div>
              <h5 className="text-sm font-extrabold text-gray-900 mb-1">Message</h5>
              <p className="text-sm text-gray-700 whitespace-pre-line bg-gray-50 border border-gray-100 rounded p-3">
                {active.message || "—"}
              </p>
            </div>
          </div>
        ) : (
          <div className="h-full flex items-center justify-center text-gray-500 text-sm">Select a lead to view details</div>
        )}
      </div>
    </div>
  );
}

export default AdminContactLeads;
